import { useContext } from "react";
import { useLoaderData } from "react-router-dom";
import { userContext } from "~/context/ContextProvider";
import * as APITypes from "~/API";
import { NonTenantHomeView, TenantHomeView } from "./components";
import type { HomePageLoaderData } from "./loaders/HomePageLoader";

export const HomePage = () => {
  const loaderData = useLoaderData() as HomePageLoaderData;
  const { status }: { status: APITypes.TenantStatusType } =
    useContext(userContext);

  if (status === APITypes.TenantStatusType.Active) {
    return <TenantHomeView {...loaderData} />;
  }

  return <NonTenantHomeView {...loaderData} />;
};

export default HomePage;
